import { RequestContext, GetDetailPageInput } from 'DVWebNodeUtils'
import { DEFAULT_PAGE_SIZE, getCollectionCurrentOffset } from '../components/collection/pagination'
import * as WpsRuntime from 'DVWebNodeWpsRuntime'
import { Omit, stringifyOnClient } from '../utils/utils'


interface IGetDetailPageInput {
    context: RequestContext,
    titleID: string,
    sections: WpsRuntime.atv.wps.SectionTypeList,
    isCrow?: boolean
    widgets?: WpsRuntime.atv.wps.Widgets,
    widgetsConfig?: WpsRuntime.atv.wps.WidgetsConfig,
    amabotContext?: WpsRuntime.atv.wps.AmabotContext,
}

export type GetAtfInput = Pick<GetDetailPageInput, 'context' | 'titleID' | 'amabotContext' | 'isCrow'>
export type GetBtfInput = Pick<GetDetailPageInput, 'context' | 'titleID'>
export type GetDetailPageInputWithoutContext = Omit<GetDetailPageInput, 'context'>
export type GetAtfInputWithoutContext = {
    titleID: string,
    atfWidgets?: WpsRuntime.atv.wps.AtfWidgetsList,
}

// TODO(AVWebDetailPage-3428): Merge getAtfInputWithoutContext and getAtfInput
export const getAtfInputWithoutContext = ({ titleID, atfWidgets }: GetAtfInputWithoutContext): GetDetailPageInputWithoutContext => {

    const input = {
        titleID,
        sections: ['Atf'],
    } as GetDetailPageInputWithoutContext

    if (atfWidgets) {
        input.widgets = stringifyOnClient({ atf: atfWidgets }) as WpsRuntime.atv.wps.Widgets
    }

    return input
}

export const getAtfInput = (args: GetAtfInput, useAmabot: boolean): GetDetailPageInput => {
    const input: IGetDetailPageInput = { ...args, sections: ['Atf'] }
    let extraWidgets: WpsRuntime.atv.wps.AtfWidgetType[] = []

    if (useAmabot) {
        extraWidgets.push("Creative")
        extraWidgets.push("BundleCarousel")
    }

    return addWidgetsToAtfInput(input, extraWidgets)
}

export const getBtfInput = (args: GetBtfInput): GetDetailPageInput => {

    return {
        ...args,
        sections: ['Btf'],
        widgets: stringifyOnClient({ 'btf': getDefaultBtfWidgets() }) as WpsRuntime.atv.wps.Widgets,
        widgetsConfig: stringifyOnClient({
            episodes: {
                startIndex: getCollectionCurrentOffset(args.context.parameters, 'episodes'),
                pageSize: DEFAULT_PAGE_SIZE
            },
            bonus: {
                startIndex: getCollectionCurrentOffset(args.context.parameters, 'bonus'),
                pageSize: DEFAULT_PAGE_SIZE
            }
        }) as WpsRuntime.atv.wps.WidgetsConfig
    }
}

// Additional is a temporary widget which helps with the migration of Gurupa widgets to 3TA.
// Its widgets belong to BTF and that's why it requests the BTF section of WPS
export const getAdditionalInput = (args: GetBtfInput, useFaq: boolean, useContactUs: boolean,
                                   useCarousel: boolean, useOtherFormats: boolean): GetDetailPageInput => {
    let input: IGetDetailPageInput = { ...args, sections: ['Btf'] }
    let extraWidgets: WpsRuntime.atv.wps.BtfWidgetType[] = []

    if (useFaq) {
        extraWidgets.push('Faq')
    }

    if (useContactUs) {
        extraWidgets.push('ContactUs')
    }

    if (useCarousel) {
        extraWidgets.push('Carousels')
    }

    if (useOtherFormats) {
        extraWidgets.push('OtherFormats')
    }

    return addWidgetsToAdditionalInput(input, extraWidgets)
}

const addWidgetsToAtfInput = (input: IGetDetailPageInput, extraWidgets: WpsRuntime.atv.wps.AtfWidgetType[]) => {
    if (extraWidgets.length == 0) {
        return input
    }

    const atfWidgets = input.widgets && input.widgets.atf? input.widgets.atf : getDefaultAtfWidgets()
    atfWidgets.push(...extraWidgets)

    return {
        ...input,
        widgets: stringifyOnClient({ 'atf': atfWidgets }) as WpsRuntime.atv.wps.Widgets,
    }
}

const addWidgetsToAdditionalInput = (input: IGetDetailPageInput, extraWidgets: WpsRuntime.atv.wps.BtfWidgetType[]) => {
    const btfWidgets = input.widgets && input.widgets.btf ? input.widgets.btf : getDefaultAdditionalWidgets()
    btfWidgets.push(...extraWidgets)

    return {
        ...input,
        widgets: stringifyOnClient({ 'btf': btfWidgets }) as WpsRuntime.atv.wps.Widgets,
    }
}

// We use functions here instead of constants in order to ensure the immutability of the arrays
export const getDefaultAtfWidgets = () => ['Header', 'BuyBox', 'Watchlist', 'Restrictions', 'Notification', 'Trailer', 'SeasonSelector', 'Self', 'Banner', 'BottomBar']
export const getDefaultBtfWidgets = () => ['Episodes', 'Bonus', 'Schedule', 'Highlights', 'Restrictions']
export const getDefaultAdditionalWidgets = () => ['ProductDetails', 'CastAndCrew', 'ScoutBanner', 'Restrictions']
